import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';

import useConfigs from '../../hooks/useConfigs';
import useFooterMenus from '../../hooks/parameter/useFooterMenus';
import { fetchListaConfiguracion } from '../../services/parameter.service';
import useThemes from '../../hooks/useThemes';
import {
  AccButton,
  Accesibilidad,
  Li,
  NavContainer,
  P,
  Ul,
} from './NavbarSuperior.elements';
import { useApi } from '../../hooks/useApi';

const NavbarSuperior = ({ showNav }) => {
  const { opcionesMenu, getOpcionesMenu } = useApi();
  const { socialMedia } = useFooterMenus();
  const { fontSizeMultiplier, changeFontSize } = useConfigs();
  const { backgroundSecundario, colorTercero } = useThemes();

  const [doctorFamedic, setDoctorFamedic] = useState(null);

  const getUrl = async () => {
    try {
      const response = await fetchListaConfiguracion({
        key: 'URL_DOCTOR_FAMEDIC',
      });
      setDoctorFamedic(response.data.list[0]?.value);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getUrl();
  }, []);

  useEffect(() => {
    getOpcionesMenu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <NavContainer
      shownav={showNav}
      style={{ backgroundColor: backgroundSecundario }}
    >
      <Ul>
        <Li>
          <a href={socialMedia?.twitter} target='_blank' rel='noreferrer'>
            <FontAwesomeIcon icon={faTwitter} color='#fff' size='lg' />
          </a>
        </Li>
        <Li>
          <a href={socialMedia?.facebook} target='_blank' rel='noreferrer'>
            <FontAwesomeIcon icon={faFacebookF} color='#fff' size='lg' />
          </a>
        </Li>
        {opcionesMenu.isLoading ? (
          <>
            <Spinner
              animation='grow'
              style={{ marginRight: '1rem', marginLeft: '3rem' }}
              variant='light'
            />
            <Spinner
              animation='grow'
              style={{ marginRight: '1rem' }}
              variant='light'
            />
            <Spinner
              animation='grow'
              style={{ marginRight: '1rem' }}
              variant='light'
            />
          </>
        ) : (
          opcionesMenu.data.secundario.map((item) => (
            <Li key={item.id}>
              <NavLink
                fontSizeMultiplier={fontSizeMultiplier}
                to={item.rutaOpcion}
                activeStyle={{
                  color: '#fff',
                  fontWeight: '700',
                  textDecoration: 'none',
                  textEmphasis: 'none',
                }}
                style={{
                  fontSize: 14 * fontSizeMultiplier,
                  color: '#fff',
                  textDecoration: 'none',
                  textEmphasis: 'none',
                }}
              >
                {item.nombreOpcion}
              </NavLink>
            </Li>
          ))
        )}
        <Accesibilidad>
          <AccButton
            active={colorTercero}
            onClick={() => changeFontSize(fontSizeMultiplier - 0.125)}
          >
            -
          </AccButton>
          <P
            style={{
              backgroundColor: colorTercero,
              color: '#fff',
            }}
          >
            Aa
          </P>
          <AccButton
            active={colorTercero}
            onClick={() => changeFontSize(fontSizeMultiplier + 0.125)}
          >
            +
          </AccButton>
        </Accesibilidad>
      </Ul>
    </NavContainer>
  );
};

export default NavbarSuperior;

NavbarSuperior.propTypes = {
  showNav: PropTypes.bool,
};
